<div class="zn-card">
    <div class="zn-card-header">
        <h4 class="zn-card-title">
            {{visibleStepItems()[activeVisibleIndex()].title }}
        </h4>
    </div>
    <div class="zn-card-body">
        <zn-stepper
          [steps]="visibleStepItems()"
          [activeIndex]="activeVisibleIndex()"
          (activeChange)="onStepperClick($event)"
        />
        <div class="zn-step">
            <div class="zn-step-header">
                <h5>
                    {{ localizationResource + '::StepOf' | abpLocalization: (activeVisibleIndex() + 1).toString() : visibleStepItems().length.toString()}}
                    - {{ visibleStepItems()[activeVisibleIndex()].title }}
                </h5>
            </div>
            <div class="zn-step-content">
                <ng-container #stepHost />
            </div>
            <hr class="zn-separator">
            <div class="zn-step-actions">
                <div class="zn-step-actions-group">
                    <zn-button type="tertiary" [label]="`${localizationResource}::Cancel` | abpLocalization"
                        iconLeft="bi bi-x-lg" (clicked)="cancel()">
                    </zn-button>
                </div>
                <div class="zn-step-actions-group">
                    <zn-button type="secondary" [label]="`${localizationResource}::Back` | abpLocalization"
                        [disabled]="isFirstStep()" (clicked)="navigatePrevious()">
                    </zn-button>
                    <zn-button [type]="isLastStep() ? 'primary' : 'secondary'" [label]="
                        (isLastStep()
                        ? finalActionLabelKey()
                        : (localizationResource + '::Next')
                        ) | abpLocalization
                        "[disabled]="isNextDisabled()" (clicked)="navigateNext()">
                    </zn-button>
                </div>
            </div>
        </div>
    </div>
</div>
